<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'almondco-freight-label-list'"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import {
  InshellTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/inventory/inshell";
import TransactionListTemplate from "../../templates/transaction-list";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {};
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Inshell Freight Labels",
        exportFileName: "Inshell Freight Labels",
        selectedIndex: GetIndexByTabName("Freight Labels"),
        tabs: InshellTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoFreightLabelList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "no-data",
                title: "No Freight Labels",
                message: "There are currently no Freight Labels",
              },
            },
          },
          toolbar: {
            search: true,
            columnChooser: true,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/almondco-freight-labels/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Branch",
              filterIndex: 0,
              filterDataField: "BranchCode",
            },
            {
              screenField: "LotNo",
              sortOrder: "desc",
              sortIndex: 1,

              filterIndex: 1,
              type: "Integer",
              filterDataField: "LotNo",
            },
            {
              screenField: "SequenceNo",
              dataField: "LotSequenceNo",
              sortOrder: "asc",
              sortIndex: 2,
            },
            {
              screenField: "AlmondcoProduct",
              filterIndex: 2,
              filterDataField: "ProductCode",
            },
            {
              screenField: "Bins",
              type: "Integer",
              label: "Bins",
              dataField: "BinCount",
            },
            {
              screenField: "GridRecordDelete",
              cssClass: "padding-7",
              DeleteOptions: {
                URL: "AlmondcoFreightLabelList",
                ReferenceKey: "RecordId",
                KeyType: "Guid",
              },
            },
          ],
        },
      };
      return config;
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (e.column.screenField != "GridRecordDelete") {
        this.onRowClicked(e, {
          view: "almondco-freight-label-detail",
          page: "almondco-freight-labels",
          mode: "review",
          idProperty: "RecordId",
          idMode: "Guid",
          query: {
            LotNo: e.data.LotNo,
            LotSequenceNo: e.data.LotSequenceNo,
            ProductCode: e.data.ProductCode,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
